export const CARD_PX = 3.5
